<template>
  <div class="home">
    <div class="header">
      <headerShow @changeLanguage="changeLanguageFN"></headerShow>
    </div>
    <div class="homeBody reportCards">
      <div class="selectOptionAll" v-if="isReport">
        <div class="selectOption">
          <div class="optionItems">
            <Tag checkable color="primary" :checked="tagCheckYear" @on-change="toggleCheckType('0')">{{$t('yearReport')}}</Tag>
            <Tag checkable color="primary" :checked="tagCheckMonth" @on-change="toggleCheckType('1')">{{$t('monthReport')}}</Tag>
            <Tag checkable color="primary" :checked="tagCheckWeek" @on-change="toggleCheckType('2')">{{$t('weekReport')}}</Tag>
          </div>
        </div>
      </div>
      <div class="reportAllClass reportCardList" v-if="isReport" style="padding:1vw 10vw">
        <Card class="cardListClass" v-for="(item,index) in dataList" :key="index" >
          <div class="cardContent">
            <div class="cardImg" :style="{backgroundImage:'url(' + item.cover + ')'}"></div>
            <div class="cardTxt">
              <div class="cardTitle" @click="goToPageFN(item.id)">{{item.title}}</div>
            </div>
          </div>
        </Card>
        <div class="resultMark_1"></div>
            <div class="resultMark_1"></div>
            <div class="resultMark_1"></div>
            <div class="resultMark_1"></div>
      </div>
      <div class="reportAllClass resultContent" style="padding:1vw 10vw" v-else>
            <div class="resultInnerItem" v-for="(item,indexs) in dataList" :key="indexs" @click="goToPageFN(item.id)">
                <div  class="resultItem" :style="{backgroundImage:'url(' + item.cover + ')'}"></div>
                <div class="resultTitle">{{item.title}}</div>
            </div>
            <div class="resultMark"></div>
            <div class="resultMark"></div>
            <div class="resultMark"></div>
            <div class="resultMark"></div>
            <div class="resultMark"></div>
            <div class="resultMark"></div>

        </div>
      <div class="resultPage">
        <Page :current="currentPage" :total="totalPageNum" @on-change="changePageFN" size="small" show-total />
      </div>
    </div>
    <footerView></footerView>
  </div>
</template>

<script>
import headerShow from '@/components/headerShow.vue'
import footerView from '@/components/footer.vue'
import { reportListRequest, selfListRequest } from '../request/request'
export default {
  name: 'home',
  components: {
    headerShow, footerView
  },
  data () {
    return {
      languageVal: 'ch',
      totalPageNum: 0,
      dataList: [],
      current: 1,
      isReport: true,
      tagCheckYear: false,
      tagCheckMonth: true,
      tagCheckWeek: false,
      reportType: 1,
      currentPage: 1
    }
  },
  computed: {
  },
  mounted () {
    this.languageVal = localStorage.getItem('language') === 'en' ? 'en' : 'ch'
  },
  created () {
    this.$nextTick(() => {
      this.initFN()
      document.scrollingElement.scrollTop = 0
    })
  },
  watch: {
    '$route' (to, from) {
      this.initFN()
    }
  },
  methods: {
    async reportListRequestFN (e) {
      var res = await reportListRequest(e)
      if (res.data.code === 0) {
        this.dataList = res.data.data.list
        this.totalPageNum = res.data.data.total
      }
    },

    async selfListRequestFN (e) {
      var res = await selfListRequest(e)
      if (res.data.code === 0) {
        this.dataList = res.data.data.list
        this.totalPageNum = res.data.data.total
      }
    },

    toggleCheckType (v) {
      this.tagCheckYear = false
      this.tagCheckMonth = false
      this.tagCheckWeek = false
      if (v === '0') {
        this.tagCheckYear = true
        this.reportType = 0
      } else if (v === '1') {
        this.tagCheckMonth = true
        this.reportType = 1
      } else if (v === '2') {
        this.tagCheckWeek = true
        this.reportType = 2
      }
      this.reportListRequestFN({ pageNum: 1, pageSize: 10, lang: this.languageVal, type: this.reportType })
    },

    changeLanguageFN (e) {
      this.languageVal = e === 'en' ? 'en' : 'ch'
      localStorage.language = this.languageVal
      if (this.$route.query.contentType) {
        this.selfListRequestFN({ pageNum: this.current, pageSize: 10, lang: this.languageVal, contentType: this.$route.query.id })
      } else {
        this.reportListRequestFN({ pageNum: this.current, pageSize: 10, lang: this.languageVal, type: this.reportType })
      }
    },

    initFN () {
      this.currentPage = parseInt(localStorage.reportListPage)
      if (this.$route.query.contentType) {
        this.isReport = false
        this.selfListRequestFN({ pageNum: localStorage.reportListPage, pageSize: 10, lang: this.languageVal, contentType: this.$route.query.id })
      } else {
        this.isReport = true
        this.reportListRequestFN({ pageNum: localStorage.reportListPage, pageSize: 10, lang: this.languageVal, type: this.reportType })
      }
    },

    changePageFN (e) {
      this.current = e
      localStorage.reportListPage = e
      if (this.$route.query.contentType) {
        this.selfListRequestFN({ pageNum: e, pageSize: 10, lang: this.languageVal, contentType:  this.$route.query.id })
      } else {
        this.reportListRequestFN({ pageNum: e, pageSize: 10, lang: this.languageVal, type: this.reportType })
      }
    },

    goToPageFN (e) {
      if (this.$route.query.contentType) {
        this.$router.push({
          path: '/costum',
          name: 'costum',
          query: {
            id: e

          }
        })
      } else {
        this.$router.push({
          path: '/reportListDetail',
          name: 'reportListDetail',
          query: {
            id: e

          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
.resultMark_1{
    width: 40%;
    margin: 0 10px;
}
.cardListClass{
    width:40%;
    margin: 0 10px;
    margin-bottom: 20px;
    height: 25vh;
}
.reportCardList{
    display: flex;
    flex-wrap: wrap;
    justify-content: center !important;
}
.cardContent{
    width: 100%;
    height: 20vh;
    @include centerLine
}
.cardImg{
    @include containbackground;
    width: 20%;
    height:100%;
}
.cardTxt{
    width: 70%;
    height:100%;
    margin-left:20px;
}
.cardTitle{
    color:#40A0F0;
    font-size: 22px;
}
</style>
